import { render, staticRenderFns } from "./scope67.vue?vue&type=template&id=0ad344a4&scoped=true"
import script from "./scope67.vue?vue&type=script&lang=js"
export * from "./scope67.vue?vue&type=script&lang=js"
import style0 from "./scope67.vue?vue&type=style&index=0&id=0ad344a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad344a4",
  null
  
)

export default component.exports